<template>
	<div>
		<section class="content-header">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-6">
						<h4>{{ $t('label.setting') }}</h4>
					</div>
					<div class="col-md-6">
						<ol class="breadcrumb float-sm-right">
							<li class="breadcrumb-item">
								<router-link to="/">{{ $t("label.home")}}</router-link>
							</li>
							<li class="breadcrumb-item">{{ $t("label.setting")}}</li>
							<li class="breadcrumb-item active">{{ $t("label.fraud")}}</li>
						</ol>
					</div>
				</div>
			</div>
		</section>
        
		<div class="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-md-12">
						<div class="card card-success card-outline">
							<div class="card-header">
								<div class="row">
									<div class="col-md-6 col-6">
										<h3 class="card-title mt-1">{{ $t("label.fraud")}}</h3>
									</div>
									<div class="col-md-6 col-6 text-right">
										<button v-if="$hasPermission('tempvehicle.fraud.create')" type="button" class="btn btn-sm btn-primary" @click="addFraud">
											<fa :icon="fas.faPlus" /> {{ $t('label.create') }}
										</button>
									</div>
								</div>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="form-group col-md-4 col-8">
										<div class="input-group">
											<input type="text" class="form-control" autofocus v-model="search" :placeholder="$t('label.search')">
											<div class="input-group-append">
												<span class="input-group-text">
													<fa :icon="fas.faSearch"/>
												</span>
											</div>
										</div>
									</div>
								</div>
								<div class="table-responsive" v-if="filteredFrauds.length > 0">
									<table class="table table-bordered mb-0">
										<tbody>
											<tr>
												<th nowrap style="width: 1%;"></th>
												<th>{{ $t('label.code') }}</th>
												<th>{{ $t('label.name') }}</th>
												<th>{{ $t('label.valid_from') }}</th>
												<th>{{ $t('label.valid_to') }}</th>
												<th nowrap style="width: 1%;"></th>
											</tr>
											<tr v-for="(item, index) in filteredFrauds" :key="index">
												<td>{{ item.id }}</td>
												<td>{{ item.code }}</td>
												<td>{{ item.name }}</td>
												<td>{{ item.valid_from }}</td>
												<td>{{ item.valid_to }}</td>
												<td>
													<a href="javascript: void(0)" @click="editFraud(item)" class="mr-1" :title="$t('label.edit')" v-if="permission.editFraud">
														<fa :icon="fas.faEdit" style="color: green;"/>
													</a>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="callout callout-success" v-else>
									<label>{{$t('label.no_data')}}</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" id="fraudModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 v-if="!fraud.id" class="modal-title" id="fraudTypeTitle">{{ $t('label.create') }}</h5>
						<h5 v-else class="modal-title" id="fraudTypeTitle">{{ $t('label.edit') }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
                        <div class="alert alert-danger" v-if="fraud.errors.length > 0">
							<p class="mb-0"><strong>Whoops!</strong> Something went wrong!</p>
							<ul>
								<li v-for="(error, index) in fraud.errors" :key="index">
									{{ error }}
								</li>
							</ul>
						</div>
						<div class="form-group row">
							<label for="fraud_code" class="col-sm-4 col-form-label">{{ $t('label.code') }} <span style="color:red" :title="$t('label.asterisk')"> *</span></label>
							<div class="col-sm-8">
								<template>
									<input v-model="fraud.code" type="text" name="fraud_code" id="fraud_code" v-validate="{required: !fraud.id, numeric: true, max:3, min:3}" class="form-control" :class="{'disabled' : fraud.id}" :readonly="fraud.id !==''">
									<span v-if="errors.has('fraud_code')" class="text-danger">{{ errors.first('fraud_code')}}</span>
								</template>
							</div>
						</div>
						<div class="form-group row">
							<label for="fraud_name" class="col-sm-4 col-form-label">{{ $t('label.name') }} <span style="color:red" :title="$t('label.asterisk')"> *</span></label>
							<div class="col-sm-8">
								<input v-model="fraud.name" type="text" name="fraud_name" id="fraud_name" v-validate="{required: !fraud.id}" class="form-control" :class="{'disabled' : fraud.id}" :readonly="fraud.id !==''">
								<span v-if="errors.has('fraud_name')" class="text-danger">{{ errors.first('fraud_name')}}</span>
							</div>
						</div>
						<div class="form-group row">
							<label class="col-sm-4 col-form-label">{{ $t('label.valid_from') }} <span style="color:red" :title="$t('label.asterisk')"> *</span></label>
							<div class="col-sm-8">
                                <datepicker @input="clearValidTo" v-model="fraud.valid_from" :disabled="fraud.id ? true : false" v-validate="{required : !fraud.id}"  :bootstrap-styling="true" :clear-button="!fraud.id" name="fraud_valid_from" id="fraud_valid_from"></datepicker>
								<span v-if="errors.has('fraud_valid_from')" class="text-danger">{{ errors.first('fraud_valid_from')}}</span>
							</div>
						</div>
						<div class="form-group row mb-0">
							<label class="col-sm-4 col-form-label">{{ $t('label.valid_to') }}</label>
							<div class="col-sm-8">
                                <datepicker :disabledDates="{ to: new Date(fraud.valid_from) }" v-model="fraud.valid_to" :required="true" :bootstrap-styling="true" :clear-button="true" name="fraud_valid_to" id="fraud_valid_to"></datepicker>
							</div>
						</div>
					</div>
					<div v-if="$hasPermission('tempvehicle.fraud.create') || $hasPermission('tempvehicle.fraud.edit')"  class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('label.close') }}</button>
						<button  v-if="!fraud.id" @click="store" type="button" class="btn btn-primary">{{ $t('label.save') }}</button>
						<button v-else @click="update" type="button" class="btn btn-primary">{{ $t('label.save') }}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { fas } from "@fortawesome/free-solid-svg-icons";

	export default {
		name: "Frauds",
		data() {
			return {
                baseURI: "",
				frauds: [],
				fraud: {
                    id: '',
                    code: '',
					name: '',
                    valid_from: '',
                    valid_to: '',
                    errors: []
				},
				permission: {
					editFraud: false,
				},
				search: ''
            };
		},
		computed: {
			fas() {
				return fas;
			},
			filteredFrauds(){
				return this.frauds.filter(fraud => {
					let search = this.search.toLowerCase();
					return fraud.name.toLowerCase().includes(search)
						|| fraud.code.toLowerCase().includes(search);
				});
			}
        },
        mounted (){
			this.getFrauds();
			
			$(".vdp-datepicker").find("input").css("background-color", "white");
        },
		methods: {
			validate() {
				this.$validator.validateAll();
				return this.errors.any();
			},
            getFrauds(){
				this.$store.state.loading.status = true;
                let url = this.baseURI + 'frauds';
                GDCE_Client.requestApi("GET", url).then(response => {
					this.frauds = response.data;
					this.$store.state.loading.status = false;
					this.permission.editFraud = this.$hasPermission('tempvehicle.fraud.edit');
				}).catch(error => {
					this.$store.state.loading.status = false;
				});
            },
            addFraud(){
                this.fraud.id = '';
                this.fraud.code = '';
                this.fraud.name = '';
                this.fraud.valid_from = '';
                this.fraud.valid_to = '';
				this.fraud.errors = [];
				this.$validator.reset();
                $("#fraudModal").modal("show");
            },
			editFraud(item) {
                this.fraud.id = item.id;
                this.fraud.code = item.code;
                this.fraud.name = item.name;
                this.fraud.valid_from = item.valid_from;
                this.fraud.valid_to = item.valid_to;
				this.fraud.errors = [];
				this.$validator.reset();
				$("#fraudModal").modal("show");
            },
            store(e){
				this.$validator.validate().then(result => {
					if (!result) {
						e.preventDefault();
					}else{
						this.$store.state.loading.status = true;
						let url = this.baseURI + 'frauds';
						GDCE_Client.requestApi("POST", url, this.fraud).then(response => {
							this.$store.state.loading.status = false;
							$('#fraudModal').modal('hide');
							this.getFrauds();
						}).catch(error => {
							this.$store.state.loading.status = false;
							if (typeof error.data === 'object') {
								this.fraud.errors = _.flatten(_.toArray(error.data.errors));
							} else {
								this.fraud.errors = ['Something went wrong. Please try again.'];
							}
						});
					}
				})
            },
            update(e){
				this.$validator.validate().then(result => {
					if (!result) {
						e.preventDefault();
					}else{
						let url = this.baseURI + 'frauds/'+ this.fraud.id;
						this.fraud.errors = [];
						GDCE_Client.requestApi("PATCH", url, this.fraud).then(response => {
							$('#fraudModal').modal('hide');
							this.getFrauds();
						}).catch(error => {
							this.$store.state.loading.status = false;
							if (typeof error.data === 'object') {
								this.fraud.errors = _.flatten(_.toArray(error.data.errors));
							} else {
								this.fraud.errors = ['Something went wrong. Please try again.'];
							}
						});
					}
				})
			},
			clearValidTo(){
				this.fraud.valid_to = '';
			}
		}
	};
</script>
<style scoped>
.disabled {
	background-color : white;
} 
</style>
